export default __webpack_public_path__ + "static/media/slide1_m_bg.2516d658.png";